import React from 'react';
import { Button } from '@/components/ui/button';

interface LoadMoreButtonProps {
  isLoading: boolean;
  remainingCount: number;
  onClick: () => void;
}

/**
 * Button component for loading more rows
 */
export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  isLoading,
  remainingCount,
  onClick,
}) => {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      disabled={isLoading}
      className="text-sm border-blue-200 text-blue-600 hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 px-6 py-2 rounded-lg shadow-subtle hover:shadow-md"
    >
      {isLoading ? (
        <div className="flex items-center gap-2">
          <div className="animate-spin rounded-full h-4 w-4 border-2 border-blue-600 border-t-transparent"></div>
          <span>Loading...</span>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <span>Load More Rows</span>
          <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs font-medium">
            {remainingCount} remaining
          </span>
        </div>
      )}
    </Button>
  );
};
